import React from 'react';
import PropTypes from 'prop-types';

import { Button as MuiButton } from '@material-ui/core';

const Button = ({ children, onClick, ...rest }) => {
  return (
    <MuiButton
      {...rest}
      onClick={onClick}
    >
      { children }
    </MuiButton>
  )
}

Button.defaultProps = {
  onClick: () => {},
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/base/Buttons/Button.js